<template>
    <div class="pop-bg" v-if="state">
        <div class="store-user-history-box">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <slot name="title">
                        会员记录
                        <i class="el-icon-close fr close" @click="close"></i>
                    </slot>
                </div>
                <div class="body flex">
                    <StoreUserHistory :id="id" />
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import StoreUserHistory from "@/model/StoreUser/StoreUserHistory";
    export default {
        name: "StoreUserHistoryBox",
        components: {StoreUserHistory},
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            id: [String, Number]
        },
        methods: {
            close: function () {
                this.$emit("stateChange", false);
            }
        }
    }
</script>

<style scoped>
    .pop-bg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
    }
    .store-user-history-box{
        margin: 50px auto 0;
        width: 1100px;
        background-color: #FFFFFF;
        border-radius: 3px;
    }
    .title{
        font-size: 16px;
        font-weight: 500;
    }
    .close{
        font-weight: bold;
        cursor: pointer;
    }
    .body{
        height: 600px;
        padding: 0px 16px;
        overflow: auto;
    }
    .foot{
        padding-bottom: 6px;
    }
</style>
